import './Footer.scss';

import Contacts from 'components/partials/contacts/Contacts';
import Image from 'components/partials/elements/components/image/Image';
import FooterNav from 'components/partials/navs/components/footer-nav/FooterNav';
import Social from 'components/partials/social/Social';
import { BBB } from 'config/core';
import { getCurrentYear } from 'helpers/dates';
import { getPageLink } from 'helpers/resources';
import _get from 'lodash/get';
import PropTypes from 'prop-types';
import React, { Suspense, lazy } from 'react';
import Container from 'react-bootstrap/Container';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import LinkExternal from '../links/components/link-external/LinkExternal';

const SignupModalButton = lazy(() =>
  import(
    'components/partials/signup-modal/components/signup-modal-button/SignupModalButton'
  )
);

const propTypes = {
  userIsLoggedIn: PropTypes.bool
};

const Footer = ({ userIsLoggedIn }) => (
  <>
    <footer className="primary-footer" role="contentinfo">
      <Container>
        <FooterNav />

        <div className="contacts-wrapper">
          <Contacts />
          <Suspense fallback={null}>
            {!userIsLoggedIn && <SignupModalButton />}
          </Suspense>
        </div>

        <div className="privacy">
          <ul>
            <li>
              <Link
                className="privacy-link"
                to={getPageLink('page-privacy-policy')}
              >
                Privacy Statements
              </Link>
            </li>
          </ul>

          <p className="disclaimer">
            &copy; {getCurrentYear()} Military Benefit Association
          </p>
          <p className="disclaimer">
            All Life insurance plans are issued by Metropolitan Life Insurance
            Company.
          </p>
          <p className="disclaimer">
            TRICARE Supplement Insurance Plan and Hospital Indemnity insurance
            Plan are underwritten by Hartford Life and Accident Insurance
            Company, Hartford, CT 06155.
          </p>

          <Social />

          <div className="bbb-wrapper">
            <LinkExternal to={BBB.url}>
              <Image
                src={BBB.logo}
                alt="Military Benefit Association BBB Business Review"
              />
            </LinkExternal>
          </div>
        </div>
      </Container>
    </footer>
  </>
);

Footer.propTypes = propTypes;

const mapStateToProps = state => ({
  userIsLoggedIn: _get(state, 'user.isLoggedIn')
});

export default connect(mapStateToProps)(Footer);
